import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { useInitPatientReports } from 'store/patients';
import CloseIcon from 'assets/svg-icons/Close';
import Spinner from 'components/FullScreenSpinner';

import { useTogglePanel } from './hooks';
import { handleItems } from './utils';
import PdfButton from './PdfButton';
import { Container, TitleWrap, Button, Title, Content, Message, Item, Text } from './styles';

const PatientReports = () => {
  const { id } = useParams();
  const [isOpen, handleClose] = useTogglePanel();
  const { loading, reports = [] } = useInitPatientReports(isOpen ? id : null);
  const items = useMemo(() => handleItems(reports), [reports]);

  return (
    <Container isOpen={isOpen}>
      <TitleWrap>
        <Button type="button" onClick={handleClose}>
          <CloseIcon />
        </Button>
        <Title>Berichte</Title>
      </TitleWrap>
      <Content>
        {loading && <Spinner height="30px" />}
        {Boolean(items.length) &&
          items.map(({ key, date, url, fileData }) => (
            <Item key={key}>
              <Text>{`Bericht vom ${date}`}</Text>
              <PdfButton fileData={fileData} url={url} />
            </Item>
          ))}
        {!(items.length || loading) && (
          <Message type="error">
            Sobald Berichte für diesen Patienten erstellt wurden, erscheinen diese hier chronologisch sortiert.
          </Message>
        )}
      </Content>
    </Container>
  );
};

export default PatientReports;
